// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"177401f8","613":"a275da4c","737":"7b33b15c"}[chunkId] + ".chunk.js";
};